export class Company {
    public username: string;
    public id: number;
    public companyName: string;
    public tin: string;
    public address: string;
    public description: string;
  }  